import { Card, CardActions, CardContent, CardHeader } from "@mui/material";
import React from "react";

const CommonCard = ({
    headerContent,
    content,
    footerContent,
    borderRadius,
    border,
    marginTop,
    paddingBottom,
    padding,
    background,
    height
}) => {
    return (
        <Card
            sx={{
                borderRadius: borderRadius || 0, 
                mt: marginTop || 2,
                boxShadow: 'none',
                pb: paddingBottom || 1,
                border: border,
                background: background || 'white',
                width: '100%'
            }}>
            {headerContent && (
                <CardHeader
                    title={headerContent}
                    sx={{ p: 0 }}
                />
            )}
            {content && (
                <CardContent
                    style={{
                        padding: padding || '16px',
                        height: height
                    }}>
                    {content}
                </CardContent>
            )}
            {footerContent && (
                <CardActions>
                    {footerContent}
                </CardActions>
            )}
        </Card>
    )
}

export default CommonCard;